import { Z_INDEX_MODAL_ABOVE_POPUP } from '@/modules/Popup/utils/popupPosition';

/** z-index por defecto del primer modal (por encima de sticky de Table ~51). */
export const MODAL_DEFAULT_Z_INDEX = 52;

/** Incremento entre modales anidados. */
export const MODAL_STACK_STEP = 50;

export const CLOSE_ALL_DROPDOWNS_EVENT = 'close-all-dropdowns';
export const CLOSE_ALL_DATEPICKERS_EVENT = 'close-all-datepickers';

const openModals = new Map<string, number>();

/**
 * Registra un modal abierto y devuelve el z-index efectivo.
 * Modales anidados con z-index por defecto quedan por encima de dropdowns/datepickers en portal (~1100).
 */
export function registerModal(modalId: string, explicitZIndex: number): number {
  let effectiveZ: number;

  if (openModals.size === 0) {
    effectiveZ = explicitZIndex;
  } else {
    const maxZ = Math.max(...openModals.values());
    const stackedZ =
      explicitZIndex === MODAL_DEFAULT_Z_INDEX
        ? Z_INDEX_MODAL_ABOVE_POPUP
        : Math.max(explicitZIndex, maxZ + MODAL_STACK_STEP);
    effectiveZ = Math.max(stackedZ, Z_INDEX_MODAL_ABOVE_POPUP);
    dispatchCloseFloatingOverlays();
  }

  openModals.set(modalId, effectiveZ);
  return effectiveZ;
}

export function unregisterModal(modalId: string): void {
  openModals.delete(modalId);
}

/** Cierra dropdowns y datepickers en portal (p. ej. al abrir modal de confirmación encima). */
export function dispatchCloseFloatingOverlays(): void {
  document.dispatchEvent(new CustomEvent(CLOSE_ALL_DROPDOWNS_EVENT));
  document.dispatchEvent(new CustomEvent(CLOSE_ALL_DATEPICKERS_EVENT));
}

/** Expuesto para tests. */
export function resetModalStackForTests(): void {
  openModals.clear();
}
